import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { Trend } from '@root/entities/trend'
import { TrendTriangle } from '@root/entities/trend/ui'

import type { PairModel } from '../../atoms/reatom-pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
  size?: number
} & ClassNameProps

export const PairInformationPriceChange: React.FC<Props> = ({
  pair,
  className,
  size = 12,
}) => {
  const [priceChange] = useAtom(pair.stats['1D'].priceChange)
  const trend = Trend.of(priceChange)

  return (
    <Percent $trend={trend} $size={size} className={className}>
      <TrendTriangle size={size} trend={trend} />

      <span>
        <Numeric
          value={Math.abs(priceChange.toNumber())}
          preset="trend-change-percents"
        />
        %
      </span>
    </Percent>
  )
}

const Percent = styled.span<{ $trend: Trend.Trend; $size: number }>`
  color: ${({ $trend }) =>
    Trend.match($trend, {
      Up: () => 'var(--up-9)',
      Down: () => 'var(--down-9)',
      Neutral: () => 'var(--neutral-11)',
    })};
  font-size: ${({ $size }) => $size}px;

  display: grid;
  grid-template-columns: auto auto;
  align-items: center;

  font-weight: 500;
  line-height: 16px;
`
